
import React from 'react'
import { Container } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import AuthNavbar from '../components/AuthNavbar/AuthNavbar';
import EditeExceptionsExpensesForm from '../components/EditeExceptionsExpensesForm/EditeExceptionsExpensesForm';
import HomeTitle from '../components/HomeTitle/HomeTitle';


function EditeExceptionsExpenses() {
            const { currentLocal } = useSelector((state) => state.currentLocal);

  return (
    <div className="home_container">
            <Container fluid className="px-0">
                <div className="home_container_row">
                    <div className="px-0">
            
                    </div>
                    <div className="px-0 my-3 w-100 dashboard_content">
                        <Container>
                            <div className="d-flex flex-column w-100">
                                <AuthNavbar />
                                <div className="mt-5 mx-3">
                                    <HomeTitle title={currentLocal.home.edit} />
                          
                                    <EditeExceptionsExpensesForm />
                                                           </div>

                            </div>
                        </Container>
                    </div>
                </div>
           
            </Container>
        </div>
          )
}

export default EditeExceptionsExpenses